import cx from 'classnames';

import { Text } from 'components/@tedui';

import { editorialize } from 'lib/business';
import useVideoPlayerStore from '../../store';

type SubtitleCueProps = {
  className?: string;
};

const SubtitleCue = ({
  className
}: SubtitleCueProps): React.ReactNode | null => {
  const subtitleCue = useVideoPlayerStore(state => state.subtitleCue);
  const subtitle = useVideoPlayerStore(
    state => state.requestedSubtitleLanguage || state.subtitle
  );

  return subtitle && subtitle !== 'OFF' && subtitleCue ? (
    <div className={cx('flex w-full flex-col', className)}>
      <div className="mx-2 flex max-w-[560px] flex-col justify-center self-center rounded-[5px] bg-black bg-opacity-[0.72] p-2 text-center lg:mx-4 lg:p-4">
        <Text
          variant="body1"
          color={{
            isOnLightSurface: false
          }}
        >
          <span
            className="whitespace-pre-line"
            dangerouslySetInnerHTML={{ __html: editorialize(subtitleCue) }}
          />
        </Text>
      </div>
    </div>
  ) : null;
};

export default SubtitleCue;
